






























import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { Component, Prop, Watch } from  'vue-property-decorator';
import UUIFComponents from '@/shared/uuifComponent';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import { CSSStyleOptions } from '@libs-uuif/shared/common-types';
import { State } from 'vuex-class';
import { RootStoreState } from '../../../store/store';
const cssPrefix = 'sharedAccordian';
@Component({
  components:{
    ...UUIFComponents,
    SwIcon,
  },
})
export default class SharedAccordian extends SwExtendedVue {
  cssPrefix = cssPrefix;

  title: string = '';

  expandAccordion: boolean = false;

  @State((state: RootStoreState) => state.CatalogStoreModule.serviceTypes)
  serviceTypes: any[];

  @State((state: RootStoreState) => state.CatalogStoreModule.rootServiceId)
  rootServiceId: any;

  @Prop()
  value: any;

  @Prop()
  preTitle: boolean;

  @Prop()
  getAccordianStyles: any;

  @Prop({ default : false })
  expandStatus: boolean;

  @Watch('value', { deep: true, immediate: true })
  private onChangePropValue() {
    this.title = this.value ? this.value.serviceName : '';
  }

  @Watch('expandStatus')
  private onChangeExpandStatus() {
    this.expandAccordion = this.getExpandStatus;
  }

  get getTitle() {
    return this.title;
  }

  get getExpandStatus() {
    return this.expandStatus;
  }

  created() {
    this.title = this.value ? this.value.serviceName : '';
    this.expandAccordion = this.expandStatus ? true : false;
  }

  get getHeaderStyles(): any {
    const wrapperStyles: CSSStyleOptions = {
      padding: this.getAccordianStyles && this.getAccordianStyles.headerPadding ? this.getAccordianStyles.headerPadding : '10px',
      color:   this.getAccordianStyles && this.getAccordianStyles.headerTextColor ? this.getAccordianStyles.headerTextColor : '#000',
      fontSize: this.getAccordianStyles && this.getAccordianStyles.headerFontSize ? this.getAccordianStyles.headerFontSize : '12px',
    };
    const iconAttributes = {
      iconSize : this.getAccordianStyles && this.getAccordianStyles.iconSize ? this.getAccordianStyles.iconSize : 12,
      iconColor: this.getAccordianStyles && this.getAccordianStyles.iconColor ? this.getAccordianStyles.iconColor : '#000',
    };
    const headerContent: CSSStyleOptions = this.getAccordianStyles && this.getAccordianStyles.headerContentStyles ?
      this.getAccordianStyles.headerContentStyles  :
      { display: 'flex' };
    return { wrapperStyles, iconAttributes, headerContent };
  }
  onOpenCloseAccordian() {
    this.expandAccordion = !this.expandAccordion;
    const updatedValue = { ...this.value };
    if (this.expandAccordion) {
      this.storeValuesToStore({ property: 'rootServiceId', with: this.value.serviceId });
      this.$emit('expandAccordian', updatedValue);
    }
  }
  storeValuesToStore(value: any) {
    this.$store.commit('CatalogStoreModule/mutate', value);
  }
}
